var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isOpen,
          expression: "isOpen",
        },
      ],
      staticClass: "dialogTemplate",
    },
    [
      _c("div", { staticClass: "dialogMask", on: { click: _vm.onClickMask } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialogFrame",
          class: { isPc: !_vm.isSp, isSp: _vm.isSp },
        },
        [
          _c(
            "div",
            { staticClass: "dialogContent", class: { isPc: !_vm.isSp } },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }